module.exports = __webpack_public_path__ + "static/media/value_prop_img_1.7bb90263.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/value_prop_img_1.jpg
// module id = 1414
// module chunks = 0